<template>
  <el-dialog :title="$t('siteBuild.vipUserInfoWidget.growthDetail', { growthName: $store.getters.projectGrowthValueName })" :visible.sync="visible" :width="$store.getters.isMobile ? '90%' : '400px'" class="dialog-base" custom-class="growth-value-detail-dialog" append-to-body :close-on-click-modal="true">
    <div class="detail-content">
      <div class="growth-summary">
        <div class="summary-head">
          <span class="summary-label">
            {{ $t('siteBuild.vipUserInfoWidget.currentGrowthValue', { growthName: $store.getters.projectGrowthValueName }) }}
          </span>
        </div>
        <div class="summary-value">{{ vipInfo?.growth || 0 }}</div>
        <div class="summary-tip">{{ growthValueTip }}</div>
      </div>

      <div class="tabs">
        <div class="tab-item" :class="{ active: currentTab === 'all' }" @click="currentTab = 'all'">
          {{ $t('siteBuild.all') }}
        </div>
        <div class="tab-item" :class="{ active: currentTab === 'increase' }" @click="currentTab = 'increase'">
          {{ $t('siteBuild.vipUserInfoWidget.increase') }}
        </div>
        <div class="tab-item" :class="{ active: currentTab === 'decrease' }" @click="currentTab = 'decrease'">
          {{ $t('siteBuild.vipUserInfoWidget.decrease') }}
        </div>
      </div>

      <div v-imloading="loading" class="list-container">
        <template v-if="list.length > 0">
          <div v-for="(item, index) in list" :key="index" class="list-item">
            <div class="left">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.time }}</div>
            </div>
            <div class="right">
              <span class="amount">{{ item.amount }}</span>
            </div>
          </div>
        </template>
        <el-empty v-else :description="$t('siteBuild.shopCart.noData')"></el-empty>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, Message, Empty } from 'element-ui'
import { formatZoneTime, getLangIdI18n } from '~/utils'
import {VipStatusTypeNameMap} from "~/enums/data"

export default {
  name: 'GrowthValueDetailDialog',
  components: {
    [Dialog.name]: Dialog,
    [Empty.name]: Empty
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      currentTab: 'all',
      list: [],
      loading: false,
      params: {
        page: 1,
        page_size: 999,
        in_or_out: 0
      }
    }
  },
  computed: {
    vipInfo() {
      return this.$store.state.project.vipInfo
    },
    growthValueTip() {
      return getLangIdI18n({ lang_id: this.model.growthValueTip }, this.$store.state.locale.langIdData)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset()
        this.fetchData()
      }
    },
    currentTab(val) {
      this.reset()
      if (val === 'all') this.params.in_or_out = 0
      else if (val === 'increase') this.params.in_or_out = 1
      else if (val === 'decrease') this.params.in_or_out = 2
      this.fetchData()
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    reset() {
      this.list = []
      this.params.page = 1
    },
    async fetchData() {
      if (this.loading) return
      this.loading = true
      try {
        const [err, res] = await this.$utils.to(this.$api.projectMember.getGrowthLogList(this.params))
        if (err) {
          Message.error(err)
          this.loading = false
          return
        }
        
        const data = res?.data || []
        const formattedData = data.map(item => ({
          title: this.$t(VipStatusTypeNameMap[item.type_name]),
          time: formatZoneTime(item.create_time * 1000).text,
          amount: item.amount
        }))
        
        this.list = formattedData
        this.loading = false
      } catch (e) {
        Message.error(e)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less">
@import '../../../widgets/common/dialogBase.less';

.growth-value-detail-dialog {
  border-radius: 12px;
  background-color: #F5F5F5;
  overflow: hidden;
  .el-dialog__header {
    background-color: #fff;
    text-align: center;
    border-radius: 12px 12px 0 0;
    .el-dialog__title {
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .detail-content {
    background-color: #F5F5F5;
    border-radius: 0 0 12px 12px;
    .growth-summary {
      position: relative;
      padding: 20px 20px 18px;
      background: linear-gradient(180deg, #FFFFFF 0%, #F6F4FF 100%);
      border-bottom: 1px solid rgba(106, 90, 249, 0.08);
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 16px;
        bottom: 16px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background: linear-gradient(180deg, #6A5AF9 0%, #9C8BFF 100%);
      }

      .summary-head {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .summary-label {
        display: inline-flex;
        align-items: center;
        padding: 4px 10px;
        border-radius: 999px;
        background: rgba(106, 90, 249, 0.08);
        color: #6A5AF9;
        font-size: 13px;
        font-weight: 500;
        line-height: 1;

        .summary-label-icon {
          margin-right: 4px;
          font-size: 14px;
        }
      }

      .summary-value {
        font-size: 32px;
        font-weight: 700;
        line-height: 1.2;
        background: linear-gradient(135deg, #6A5AF9 0%, #9C8BFF 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        letter-spacing: 0.5px;
      }

      .summary-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #999;
      }
    }

    .tabs {
      display: flex;
      justify-content: space-around;
      background-color: #fff;
      padding-bottom: 5px;

      .tab-item {
        padding: 10px 0;
        font-size: 14px;
        color: #999;
        cursor: pointer;
        position: relative;
        
        &.active {
          color: #6A5AF9;
          font-weight: 600;
        }
      }
    }

    .list-container {
      padding: 20px 12px 20px;
      max-height: 400px;
      overflow-y: auto;
      position: relative;
      .list-item {
        background-color: #fff;
        padding: 12px 15px;
        border-radius: 4px;
        margin-bottom: 8px;
        display: flex !important;
        justify-content: space-between;
        align-items: center;

        .left {
          .title {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            margin-bottom: 4px;
          }
          
          .time {
            font-size: 12px;
            color: #999;
            transform: scale(0.9);
            transform-origin: left;
          }
        }

        .right {
          .amount {
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }
        }
      }
    }
  }
}
</style>
